import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as constants from '../_model/string_literal';
import { getTenantData, postTenantData } from '../_model/tenant';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  tenantList: getTenantData[] = [];
  _tenantDataChanged = new BehaviorSubject<boolean>(false);
  tenantDataChanged: boolean = false;
  selectedTenantID = '';
  editTenantData!: postTenantData;
  editTenantFlag = false;
  skipListFlag = false;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    const parsedToken = token ? JSON.parse(token) : null;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': parsedToken?.token ? `Bearer ${parsedToken.token}` : ''
    });
  }

  get httpOptionsAuth() {
    return { headers: this.getAuthHeaders() };
  }

  constructor(
    private http: HttpClient,
  ) { }

  getTenantList() {
    return this.http.get<getTenantData[]>(constants.IAPI_ENDPOINT + '/tenant',this.httpOptionsAuth);
  }

  getTenantByID(id: any) {
    return this.http.get(constants.IAPI_ENDPOINT + `/tenant?tenant_id=${id}`,this.httpOptionsAuth);
  }

  getTenantByUserID(user_id: any) {
    return this.http.get(constants.IAPI_ENDPOINT + `/tenant/user?user_id=${user_id}`,this.httpOptionsAuth);
  }

  getTenantByCompanyID(company_id: any) {
    return this.http.get(constants.IAPI_ENDPOINT + `/tenant/company?company_id=${company_id}`,this.httpOptionsAuth);
  }

  updateTenant(tenantData: any){
    return this.http.put(constants.IAPI_ENDPOINT + `/tenant?tenant_id=${this.selectedTenantID}`, JSON.stringify(tenantData), this.httpOptionsAuth);
  }

  createTenant(tenantData: any){
    return this.http.post(constants.IAPI_ENDPOINT + '/tenant', JSON.stringify(tenantData), this.httpOptionsAuth);
  }

  deleteTenant() {
    return this.http.delete(constants.IAPI_ENDPOINT + `/tenant?tenant_id=${this.selectedTenantID}`, this.httpOptionsAuth);
  }
}